<script setup lang="ts">
import { computed, toRefs } from "vue";
import type { PropType } from "vue";
import type { ITreeNode } from "../interfaces";
import type { IUser } from "@/types";
import SidebarMenuItem from "./SidebarMenuItem.vue";

const props = defineProps({
  item: {
    type: Object as PropType<ITreeNode>,
    required: true,
  },

  user: {
    type: Object as PropType<IUser>,
    required: true,
  },
});

const emit = defineEmits(["newPath"]);

const { item } = toRefs(props);

const isSection = computed(() => {
  return item.value.type === "section";
});

const getItems = (item: ITreeNode) => {
  return isSection.value ? item.items : [item];
};
</script>

<template>
  <div>
    <div v-for="(menuItem, index) in getItems(item)" :key="index">
      <SidebarMenuItem
        :item="menuItem"
        :user="user"
        @newPath="emit('newPath', $event)"
      />
    </div>
  </div>
</template>
